import { AfterViewInit, Component, ElementRef, Input, Renderer2, TemplateRef, ViewChild, ComponentFactoryResolver, ViewContainerRef, NgZone, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Channel, LINK_TYPES, LinkService, Notification} from '@portals/api';
import {BaseComponent, ResponseService, WindowRef} from '@portals/core';
import { ChannelsState, NotificationsState, UsersState } from '@portals/store';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { finalize, tap } from 'rxjs';
import { CookieService } from 'ngx-cookie';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { MatDialog } from '@angular/material/dialog';
import { customAlphabet } from 'nanoid';
import { AppService } from '@portals/api';
import { DeviceDetectorService } from 'ngx-device-detector';
import {environment} from "@portals/environments";

@Component({
	selector: 'jotto-app-channel-feed',
	templateUrl: './channel-feed.component.html',
	styleUrls: ['./channel-feed.component.scss'],
})
export class ChannelFeedComponent extends BaseComponent implements AfterViewInit {
	notifications: Notification[] = []
	channel = <Channel>this.responseService.currentPage?.parameters?.channel;
	@Input() maxFeedHeight = '700px';
	@Input() feedWidth = '370px';
	@ViewChild('appContainer', { static: true }) appContainerRef!: ElementRef;
	@ViewChild('mobileView', { static: true }) mobileViewRef!: ElementRef;
	@ViewChild('channelContent', { static: true }) channelContentRef!: ElementRef;
	uuid = customAlphabet('1234567890abcdef', 10)();
	feedLoading = false;
	loaderConfig = {
		animationType: ngxLoadingAnimationTypes.pulse,
		primaryColour: `var(--portals-theme-primary)`,
		secondaryColour: `var(--portals-theme-accent)`,
	};
	isDesktop: boolean;
	isMobile: boolean;
	isTablet: boolean;
	maxHeight = '';
	qrcode!: any;
	dialogRef: any;
	elementType = NgxQrcodeElementTypes.IMG;
	correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
	form: FormGroup;
	protected readonly LINK_TYPES = LINK_TYPES;


	constructor(private app: AppService, public router: Router, private route: ActivatedRoute, private formBuilder: FormBuilder, private channelState: ChannelsState, private cookies: CookieService, private user: UsersState, private notificationsState: NotificationsState, private deviceService: DeviceDetectorService, private renderer: Renderer2, protected zone: NgZone, public dialog: MatDialog, public window: WindowRef, public linkService: LinkService, public responseService: ResponseService) {
		super();
		window.nativeWindow.resizeTo(300, 600);
		this.isDesktop = this.deviceService.isDesktop();
		this.isMobile = this.deviceService.isMobile();
		this.isTablet = this.deviceService.isTablet();
		const windowHeight = this.isMobile ? window.nativeWindow.innerHeight : 600;
		this.maxHeight = `${windowHeight - 304}px`;
		this.feedWidth = this.isMobile ? '-webkit-fill-available' : '370px';
		this.feedLoading = true;
		this.form = this.formBuilder.group({
			first_name: [`web-user`],
			last_name: [this.uuid],
			username: [this.uuid],
			password: [this.uuid],
			confirmed: [true],
			blocked: [false],
			role: [1, Validators.required],
			web: [true],
		});

		this.notifications = this.notificationsState.data

		this.subscribe(
			this.notificationsState.loadChannelFeed(this.channel.id).pipe(
				tap((data) => {
					this.notifications = data
				}),
				finalize(() => {
					this.feedLoading = false;
				})
			)
		);
	}

	ngAfterViewInit() {
		this.feedLoading = true;
		const portrait = window.matchMedia('(orientation: portrait)');
		if (this.deviceService.isMobile()) {
			portrait.matches ? null : this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-width', '100%');
		}

		if (this.isMobile) {
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'width', '100%');
			// this.renderer.setStyle(this.channelContentRef.nativeElement, 'padding', '0px 28px 0px');
			// this.renderer.setStyle(this.channelContentRef.nativeElement, 'max-height', this.maxHeight);
			this.renderer.setStyle(this.appContainerRef.nativeElement, 'background', 'var(--portals-theme-primary)');
			this.renderer.setStyle(this.appContainerRef.nativeElement, 'height', '100vh');
			this.renderer.setStyle(this.appContainerRef.nativeElement, 'max-height', window.innerHeight + 'px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'padding', '20px 0p');
		}

		if (this.isTablet) {
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'border-radius', '24px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'min-height', '650px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-height', '650px');
			this.renderer.setStyle(this.appContainerRef.nativeElement, 'width', '100%');
			if (this.deviceService.device == 'iPhone' && this.deviceService.browser == 'Chrome') {
				this.renderer.setStyle(this.mobileViewRef.nativeElement, 'padding-bottom', '10px');
			}
		}

		if (this.isDesktop) {
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'min-width', '370px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-width', '370px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'min-height', '650px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-height', '650px');
		}
	}

    protected readonly environment = environment;
}
